import { useEffect, useRef } from "react";

const useSlider = (intervalMs = 3500) => {
  const slidesRef = useRef(null);
  const indexRef = useRef(0);

  useEffect(() => {
    const slidesEl = slidesRef.current;
    if (!slidesEl) return;

    const moveSlider = () => {
      if (!slidesEl || !slidesEl.children.length) return;
      indexRef.current = (indexRef.current + 1) % slidesEl.children.length;
      const width = slidesEl.children[0].offsetWidth + 12;
      slidesEl.style.transform = `translateX(${-(indexRef.current * width)}px)`;
    };

    const id = setInterval(moveSlider, intervalMs);

    const onResize = () => {
      if (!slidesEl) return;
      slidesEl.style.transform = "translateX(0)";
      indexRef.current = 0;
    };

    window.addEventListener("resize", onResize);

    return () => {
      clearInterval(id);
      window.removeEventListener("resize", onResize);
    };
  }, [intervalMs]);

  return slidesRef;
};

export default useSlider;
